import Download from '../../src/legacy/Download';
export default Download;
